import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { distances, border, colors } from '../../styles/constants';
import { H2, P } from '../../components/Typography';
import { Session, Transaction } from '../../types/checkout';
import FullAddress from '../transactionDetails/components/FullAddress';
import Hr from '../../components/Hr';
export interface CustomerInfoProps extends WithTranslation {
    transaction?: Transaction;
    session?: Session;
}

const billingAddress = (
    {
        t,
        session,
        transaction,
    }: CustomerInfoProps
) => {
    const sessionBillingAddress = session && session.order.billing_address;
    const billingAddress = transaction?.billing_address || sessionBillingAddress;
    return (
        <Wrapper>
            <H2>{t('payments.transaction.billing_address')}</H2>
            <Hr />
            {!billingAddress && <P>{t(transaction ? 'payments.transaction.no_billing_address' : 'payments.session.no_billing_address')}</P>}
            {billingAddress && <FullAddress address={billingAddress} />}
        </Wrapper>
    );
};

export default withTranslation()(billingAddress);

const Wrapper = styled.div`
    padding-top: ${distances.normal};
    width: 100%;
`;
